// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1aocH","modalForm":"UpgradeEpcsModal_modalForm__2v4en","modalFooter":"UpgradeEpcsModal_modalFooter__220bx"};